import http from "../http-common";

class ItemDataService {
  getAll() {
    return http.get("/items/search/");
  }

  getCondition(condition) {
    return http.get(`/items/search/?desc=${condition}`);
  }

  getItemByPartNumber(condition, sortfield,sorttype) {
    return http.get(`/items/searchpartnumber/?itempartnumber=${condition}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }

  getItemByDescr(condition, sortfield,sorttype) {
    return http.get(`/items/searchdescription/?itemdescription=${condition}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }

  getItemByCategory(condition, sortfield,sorttype) {
    return http.get(`/items/searchcategory/?itemcategory=${condition.itemcategory}&itemcategoryval=${condition.itemcategoryval}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }

  get(id) {
    return http.get(`/items/${id}`);
  }

  create(data) {
    return http.post("/items/newitem", data);
  }

  update(id, data) {
    return http.put(`/items/${id}`, data);
  }

  delete(id) {
    return http.delete(`/items/${id}`);
  }

  deleteAll() {
    return http.delete(`/items`);
  }

  findById(id) {
    return http.get(`/items?id=${id}`);
  }
}

export default new ItemDataService();